import { render, staticRenderFns } from "./link-conversations-drawer.vue?vue&type=template&id=8008023c&"
import script from "./link-conversations-drawer.vue?vue&type=script&lang=ts&"
export * from "./link-conversations-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./link-conversations-drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports